class CallCenter extends HTMLElement {
  constructor() {
    super();

    this.device = window.deviceDetector.getDevice();
    this.isBindEventExecute = false;

    this.buttonOpen = this.querySelector('.menu-navigation__drawer-open');
    this.targetNavigate = this.querySelector('.menu-navigation');

    this.btnCloseNavigate = this.targetNavigate.querySelector('#menu-navigation__drawer-btn-close');
    this.overlay = this.targetNavigate.querySelector('.menu-navigation__drawer-overlay');

    this.bindEvents();
    if (this.device === 'mobile') {

      this.isBindEventExecute = true;
    }

    window.addEventListener('device:change', event => {
      this.device = event.detail.device;

      if (!this.isBindEventExecute && this.device === 'mobile') {
        this.bindEvents();
      }
    });

    this.closeFilter = this.closeFilter.bind(this);
  }

  bindEvents() {
    this.buttonOpen.addEventListener('click', () => {
      this.targetNavigate.classList.remove('close');
      this.targetNavigate.classList.add('open');

      document.body.classList.toggle('menu-drawer-open');
      
      this.btnCloseNavigate.addEventListener('click', this.closeFilter);
      this.overlay.addEventListener('click', this.closeFilter);
    });
  }

  closeFilter() {
    this.targetNavigate.classList.add('close');

    setTimeout(() => {
      document.body.classList.remove('menu-drawer-open');
      this.targetNavigate.classList.remove('open');
    }, 300);

    this.btnCloseNavigate.removeEventListener('click', this.closeFilter);
    this.overlay.removeEventListener('click', this.closeFilter);
  }
}

customElements.define('call-center', CallCenter);